import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { Converter } from '../converter.interface';
import { DependencyItemObject } from 'src/app/models/catalog/dependency-item-object.model';

@Injectable({
    providedIn: 'root'
})

export class DependencyItemObjectConverter implements Converter<Array<DependencyItemObject>> {

    convert(input: any): Array<DependencyItemObject> {
        const dependencies = new Array<DependencyItemObject>();
        if (isNullOrUndefined(input)) {
            return new Array();
        }

        input.forEach(element => {
            dependencies.push(new DependencyItemObject(element.name, element.activation));
        });

        return dependencies;

    }

}
